import { React, useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { updateTableActions } from '../../store/update-table-slice';
import axios from 'axios';
import { Delete } from '@mui/icons-material';
import Notification from '../Notification';
import ConfirmDialog from '../ConfirmDialog';
import { useNavigate } from 'react-router-dom';
import { formatDate } from '../../common/constants';

let fetch_id = 0;

export default function LeaveDataMasterTable(props) {

  const [openPopup, setOpenPopup] = useState(false);
  const [leaves, setLeaves] = useState([]);
  const [notify, setNotify] = useState({ isOpen: false, message: '', type: '' });
  const [confirmDialog, setConfirmDialog] = useState({ isOpen: false, title: '', subTitle: '' });
  const navigate = useNavigate();

  const updateEmpLeave = useSelector(state => state.updateTable.updateEmpLeave);
  const dispatch = useDispatch();


  let API_URL = "";

  async function getAllEmployees() {
    if (props.fetch_id != 9999) {
      API_URL = `${process.env.REACT_APP_API_BASE_URL}/employee-master/view-emp-leaves/` + props.fetch_id;   // We came by editing meny
    } else {
      API_URL = `${process.env.REACT_APP_API_BASE_URL}/employee-master/view-emp-leaves/` + props.employeeID;  //We came After insertion
    }

    try {
      const leaves = await axios.get(API_URL);
      setLeaves(leaves.data);
    } catch (e) {
      if (e.response.status === 401) {
        setNotify({
          isOpen: true,
          message: 'Session Expired!',
          type: 'error'
        });
        setTimeout(() => {
          navigate('/');
        }, 1000);
      }
    }
  }

  useEffect(() => {
    getAllEmployees();
  }, []);

  useEffect(() => {
    if (updateEmpLeave) {
      getAllEmployees();
      dispatch(updateTableActions.stopUpdateEmpLeave());
    }
  });

  const handleDelete = async (employee_leave_data_master_id) => {
    setConfirmDialog({
      ...confirmDialog,
      isOpen: false
    });
    try {
      const res = await axios.delete(`${process.env.REACT_APP_API_BASE_URL}/employee-master/delete-emp-leave/` + employee_leave_data_master_id);
      getAllEmployees();
      setNotify({
        isOpen: true,
        message: 'Successfully Deleted!',
        type: 'error'
      });
      dispatch(updateTableActions.startUpdateEmpLeave());
    } catch (e) {
      if (e.response.status === 401) {
        setNotify({
          isOpen: true,
          message: 'Session Expired!',
          type: 'error'
        });
        setTimeout(() => {
          navigate('/');
        }, 1000);
      }
    }
  }

  return (
    <div>

      <table class="table">
        <thead class="table-dark">
          <tr>
            <th scope="col">Leave Type</th>
            <th scope="col">From Date</th>
            <th scope="col">To Date</th>
            <th scope="col">Reason For Leave</th>
            <th scope="col">Total Days</th>
            <th scope="col">Half Day</th>
            <th scope="col">Date of Leave</th>
            <th scope="col" class="table-dark"></th>
          </tr>
        </thead>
        <tbody>


          {leaves.map((leave) => {

            return (
              <tr >
                <td>{leave.leaveTypeName}</td>
                {/* Apply formatDate function to the date fields */}
                <td>{leave.from_date ? formatDate(leave.from_date) : '-'}</td>
                <td>{leave.to_date ? formatDate(leave.to_date) : '-'}</td>
                <td>{leave.reason_for_leave}</td>
                <td>{leave.total_leave_days}</td>
                <td>{leave.half_day === 1 ? 'Yes' : 'No'}</td>
                <td>{leave.dateofleave ? formatDate(leave.dateofleave) : '-'}</td>
                <td><button
                  type="button"
                  class="btn btn-outline-danger btn-sm"
                  onClick={() => setConfirmDialog({
                    isOpen: true,
                    title: 'Are you sure to delete this record?',
                    subTitle: "You can't undo this operation",
                    onConfirm: () => { handleDelete(leave.employee_leave_data_master_id) }
                  })} >

                  <Delete /> Delete
                </button></td>
              </tr>
            )
          })}

        </tbody>
      </table>

      <Notification
        notify={notify}
        setNotify={setNotify} />
      <ConfirmDialog
        confirmDialog={confirmDialog}
        setConfirmDialog={setConfirmDialog} />

    </div>


  );
}
